<template>
  <div>
    <QS-scroller-box>
      <div class="details_content_title">
        <QS-h3-title class="purchase" title="维保项目详情"></QS-h3-title>
      </div>
      <el-button type="primary" @click="handleGoToPaget('1')">查看租赁方案绑定记录</el-button>
      <el-button type="primary" @click="handleGoToPaget('2')">查看租赁订单绑定记录</el-button>
      <el-button type="primary" @click="handleGoToPaget('3')">查看维保订单</el-button>
      <detail-base-info
        labelWidth="130"
        title="基本信息"
        :source="detailData"
        :list="baseInfoColumns"
      >
      <template>
          <div class="column_content_mrbtm">
            <div class="column-title">方案图片:</div>
            <el-image
              v-if="detailData.logo"
              style="width: 100px; height: 100px"
              :src="detailData.logo"
              fit="fit"
            ></el-image>
          </div>
        </template>
      </detail-base-info>

      <QS-h4-title title="套餐商品" />
      <projectList
      v-for="item in projectData"
      :key="item.id"
      :source="item"
      :isStatus="true"
      >
      <template slot="footer">
        <el-form class="store-form" label-width="120px">
          <div v-if="detailData.maintenanceType === 3">
            <el-form-item prop="maxUseAmount" label="最大消费金额:">
              <el-input disabled :value="detailData.maxUseAmount"/>
            </el-form-item>
            <el-form-item prop="maxUseTime" label="最大消费次数:">
              <el-input disabled  :value="detailData.maxUseTime"/>
            </el-form-item>
            <el-form-item prop="maxSingleUseAmount" label="最大单词消费金额:">
              <el-input disabled :value="detailData.maxSingleUseAmount"/>
            </el-form-item>
            <el-form-item prop="expireMonth" label="有效期:">
              <el-input disabled :value="detailData.expireMonth"/>
            </el-form-item>
          </div>
          <el-form-item prop="businesses" label="套餐可使用门店:">
            <el-tag
              type="info"
              v-for="child in detailData.businesses"
              :key="child.businessId"
              >{{ child.businessName }}</el-tag
            >
          </el-form-item>
        </el-form>
      </template>
      </projectList>

      <template slot="bottomAction">
        <div class="btns">
          <el-button type="primary" @click="handleGoBack">关闭</el-button>
        </div>
      </template>
    </QS-scroller-box>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { maintenanceDetailtApi } from '../services'
import config from '../config'
import detailBaseInfo from '@/components/detailsComponents/detailBaseInfo.vue'
import projectList from '@/pages/customers/servicesManage/maintenanceReview/components/projectList/projectList.vue'
import maintenanceTypes from '@/store/dict/maintenance'


export default {
  name: '',
  components: {
    detailBaseInfo,
    projectList,
  },
  data() {
    const { baseInfoColumns } = config.call(this)
    return {
      baseInfoColumns,
      detailData: {},
      projectData: [],
    }
  },
  methods: {
    handleGoToPaget(type) {
      const { orderId, collaborationId } = this.$route.query
      const paths = {
        1: '/vehicle/maintenance/leasePlan',
        2: '/vehicle/maintenance/leaseOrder',
        3: '/vehicle/maintenance/list',
      }

      this.$router.push({
        path: paths[type],
        query: {
          itemId: orderId,
          collaborationId,
        },
      })
    },
    handleGoBack() {
      this.$refreshBack(false)
    },
    async getmaintenanceDetailt() {
      const { orderId } = this.$route.query
      const { code, data } = await maintenanceDetailtApi({ id: orderId })
      if (code === 1 && data) {
        this.projectData = [{ ...data }]
        if (data.maintenanceType === 1) {
          data.maintenanceTypeText = '维修'
        } else if (data.maintenanceType === 0) {
          data.maintenanceTypeText = '保养'
        } else {
          data.maintenanceTypeText = '--'
        }

        data.packageTypeText = maintenanceTypes.projectTypesDetails[data.packageType] || '--'

        if (data.state === 0) {
          data.stateText = '无效'
        } else if (data.state === 1) {
          data.stateText = '有效'
        } else {
          data.stateText = '--'
        }
        data.expireDay += '天'
        this.detailData = data
      }
    },
  },
  created() {
    this.getmaintenanceDetailt()
  },
}
</script>

<style lang="scss" scoped>
</style>
